import { InternalAxiosRequestConfig } from "axios";
import i18next from "i18next";
import { getAccessToken } from "../token";

export const requestInterceptor = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const token = getAccessToken();
    if (token && config.headers) {
        config.headers.Authorization = token;
    }

    try {
        config.headers["Accept-Language"] = i18next.language || "en";
    } catch {
        config.headers["Accept-Language"] = "en";}

    return config;
};
